import React from "react";
import { navigate } from "gatsby";
import Loading from "../loading/loading";
import { useAuthentication } from "../../hooks/auth/useLogin";
import Login from "../wallet/login";
import Button from "../common/button/button";

//This will be the gatekeeper for pages that need authentication with firebase
const PrivateRoute = ({ component: Component, location, ...rest }) => {
  const { authLoading, isLoggedIn } = useAuthentication();

  if (authLoading) {
    return (
      <div className="flex flex-col h-full place-content-center">
        <div className="mt-16 mx-auto">
          <Loading size={32} />
        </div>
      </div>
    );
  } else if (isLoggedIn) {
    return <Component {...rest} />;
  } else {
    return (
      <div className="flex flex-col flex-grow justify-center">
        <div className="flex flex-col items-center justify-center space-y-16 pb-64 lg:pb-208">
          <p className="body2 text-dark-white-64 pb-16">
            Your wallet is not connected
          </p>
          <div className="flex flex-row justify-center">
            <Login width="full" size="md" />
          </div>
          <Button size="md" fill={false} onClick={() => navigate("/explore")}>
            Explore albums
          </Button>
        </div>
      </div>
    );
  }
};

export default PrivateRoute;
